var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dad7e5;}.cls-2{fill:#edebf2;}.cls-3{fill:#8bd1ea;}.cls-4{fill:#9fdbf3;}.cls-5{fill:#84b749;}.cls-6{fill:#b5e08c;}.cls-7{fill:#9dcc6b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time is money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time_is_money",
    "data-name": "Time is money"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,18a16.88,16.88,0,0,1-4,11c0,.1-1.81,0-16,0v5.73C.87,32.23-3.94,14.31,7,5S35,3.36,35,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35,18a16.88,16.88,0,0,1-4,11c0,.37-7.11,6-16,3.27A17,17,0,0,1,7,5C17.87-4.18,35,3.36,35,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.92,29H15v1.65C8.67,29.17,4.33,22.94,5.05,17A13,13,0,1,1,24.92,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29,20a12.91,12.91,0,0,1-2.84,8.1,10.06,10.06,0,0,1-1.24.9H15v1.65A13,13,0,0,1,7.88,9.85,13,13,0,0,1,29,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47,34v8a5,5,0,0,0-5,5H20a5,5,0,0,0-5-5V34a5,5,0,0,0,5-5H42A5,5,0,0,0,47,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47,29v5a5,5,0,0,1-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47,42v5H42A5,5,0,0,1,47,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20,29a5,5,0,0,1-5,5V29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20,47H15V42A5,5,0,0,1,20,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47,29v5a5,5,0,0,1-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47,42v3H42.41A5,5,0,0,1,47,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47,34v8a5,5,0,0,0-4.59,3H33A16,16,0,0,1,17.58,33.28,5.07,5.07,0,0,0,20,29H42A5,5,0,0,0,47,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20,29a5,5,0,0,1-2.42,4.28A15.91,15.91,0,0,1,17,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,28H32.94A18,18,0,1,0,14,35.53V47a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V29A1,1,0,0,0,47,28ZM41.09,46H20.91A6,6,0,0,0,16,41.09V34.91A6,6,0,0,0,20.91,30H41.09A6,6,0,0,0,46,34.91v6.18A6,6,0,0,0,41.09,46ZM9.29,25.29l-.46.46A12,12,0,0,1,6,19H7a1,1,0,0,0,0-2h-1a11.9,11.9,0,0,1,2.8-6.74c.49.49.67.74,1.15.74a1,1,0,0,0,.71-1.71l-.45-.44A11.9,11.9,0,0,1,17,6.05V7a1,1,0,0,0,2,0v-1a11.9,11.9,0,0,1,6.74,2.8l-.45.44A1,1,0,0,0,26,11c.49,0,.68-.27,1.15-.74A11.9,11.9,0,0,1,30,17H29a1,1,0,0,0,0,2h.94a11.88,11.88,0,0,1-2.79,6.73l-.44-.44a1,1,0,0,0-1.42,1.42l.45.44A10.54,10.54,0,0,1,24.6,28H15a1,1,0,0,0-1,1v.31a11.89,11.89,0,0,1-3.75-2.14l.46-.46A1,1,0,0,0,9.29,25.29ZM18.86,30A4,4,0,0,1,16,32.86V30ZM46,32.86A4,4,0,0,1,43.14,30H46ZM2,18A16,16,0,1,1,30.46,28H27.79C36.69,19.33,30.57,4,18,4a14,14,0,0,0-4,27.41v2.07A15.94,15.94,0,0,1,2,18ZM16,43.14A4,4,0,0,1,18.86,46H16ZM43.14,46A4,4,0,0,1,46,43.14V46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,23c.56,0,.5-.09,3.49-3.07A2,2,0,0,0,19,16.28V10a1,1,0,0,0-2,0v6.28A2,2,0,0,0,16,18c0,.79.68-.1-2.71,3.29A1,1,0,0,0,14,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,35a1,1,0,0,1,1,1,1,1,0,0,0,1,1c1.66,0,1.21-3-1-3.82a1,1,0,1,0-2,0A3,3,0,0,0,31,39a1,1,0,1,1-1,1,1,1,0,0,0-1-1c-1.66,0-1.21,3,1,3.82a1,1,0,1,0,2,0A3,3,0,0,0,31,37,1,1,0,0,1,31,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,37H21a1,1,0,0,0,0,2h2A1,1,0,0,0,23,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,37H39a1,1,0,0,0,0,2h2A1,1,0,0,0,41,37Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.d8ee7c51da69c1c44b6cd15c6f014218.svg";
export { ForwardRef as ReactComponent };